import { apiClient } from '@/lib/api-client';

export type PromptType = 'Fullness' | 'Count';

export interface PromptListRow {
  id: string;
  version: string;
  is_active: boolean;
  prompt_type: PromptType;
  created_at: string;
  updated_at: string;
}

interface ApiEnvelope<T> {
  data: T;
  message?: string;
  success?: boolean;
}

// Server-side ListAsync orders active-first then created_at desc, which is
// the same order the picker wants — no re-sort needed.
export async function listPrompts(signal?: AbortSignal): Promise<PromptListRow[]> {
  const res = await apiClient.get<ApiEnvelope<PromptListRow[]>>('/api/v1/prompts', { signal });
  return res.data.data ?? [];
}
